import React from "react";
import { Grid, Typography, TextField } from "@mui/material";
import { useDispatch ,useSelector } from "react-redux";
import { updateFormField } from "features/OrgAdmin/orgAdminSlice";
import { styled } from "@mui/material/styles";

// Updated StyledPaper with padding and light shadow
const StyledPaperEnhanced = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2.5),
  borderRadius: theme.shape.borderRadius,
  boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
  marginBottom: theme.spacing(2),
}));

function ConfigFields() {
  const dispatch = useDispatch();
  const formData = useSelector((state) => state.org.formData);
  return (
    <>
      <Grid item xs={12} md={12}>
        <StyledPaperEnhanced>
          <Typography variant="subtitle1" fontSize="0.9rem" gutterBottom>
            Web View API Key
          </Typography>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            placeholder="Enter Web View API Key"
            value={formData?.webApiKey || ""}
            onChange={(e) =>
              dispatch(
                updateFormField({ field: "webApiKey", value: e.target.value })
              )
            }
          />
        </StyledPaperEnhanced>
      </Grid>

      <Grid item xs={12} md={12}>
        <StyledPaperEnhanced>
          <Typography variant="subtitle1" fontSize="0.9rem" gutterBottom>
            Vendor Handle
          </Typography>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            placeholder="Enter Vendor Handle"
            value={formData?.vendorHandle || ""}
            onChange={(e) =>
              dispatch(
                updateFormField({
                  field: "vendorHandle",
                  value: e.target.value,
                })
              )
            }
          />
        </StyledPaperEnhanced>
      </Grid>
    </>
  );
}

export default ConfigFields;
